export default {
  type: String,
  default: '4px'
}
